import { render, staticRenderFns } from "./panel_yajin.vue?vue&type=template&id=57da588a&scoped=true&"
import script from "./panel_yajin.vue?vue&type=script&lang=js&"
export * from "./panel_yajin.vue?vue&type=script&lang=js&"
import style0 from "./panel_yajin.vue?vue&type=style&index=0&id=57da588a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57da588a",
  null
  
)

export default component.exports